import {LatLng} from "leaflet";
import {
    GeoPosition,
    SearchQuery,
    SearchQueryTag,
    SearchQueryTagSuggestion
} from "../models/search_query";
import {RatingProfileId, SearchState} from "../models/models";

export function urlWithRatingProfileIdParam(initialUrl: string, ratingProfileId: RatingProfileId): URL {
    const url = new URL(initialUrl);
    const params = new URLSearchParams();
    if (ratingProfileId) {
        params.set("rating_profile_id", ratingProfileId.toString());
    }
    url.search = params.toString();
    return url;
}

export function latLngToArray(latLng: LatLng | undefined): [lat: number, lng: number] | undefined {
    if (!latLng) {
        return undefined;
    }

    const { lat, lng } = latLng;
    return [lat, lng];
}

export function searchQueryFromSearchState(searchState: SearchState): SearchQuery {
    const { searchQueryTags, mapInfo } = searchState;
    return {
        queryTags: searchQueryTags,
        center: latLngToArray(mapInfo?.center),
        southWest: latLngToArray(mapInfo?.bounds?.getSouthWest()),
        northEast: latLngToArray(mapInfo?.bounds?.getNorthEast()),
        zoom: mapInfo?.zoom
    };
}

export function geoLocationFromPlaceSearchQueryTag(queryTag: SearchQueryTag | undefined): GeoPosition | null {
    if (!queryTag || queryTag.type !== "place") {
        return null;
    }

    return geoLocationFromSearchQueryTagValue(queryTag.value);
}

export function geoLocationFromSearchQueryTagValue(value: string | null): GeoPosition | null {
    const splitVal = (value ?? "").split("/");
    if (splitVal.length === 3) {
        return { lat: parseFloat(splitVal[1]), lng: parseFloat(splitVal[2]) };
    } else if (splitVal.length === 2) {
        return { lat: parseFloat(splitVal[0]), lng: parseFloat(splitVal[1]) };
    } else {
        return null;
    }
}

export function suggestionFromSearchQueryTagValue(tag: SearchQueryTag, allSuggestions: SearchQueryTagSuggestion[] | undefined): SearchQueryTagSuggestion | undefined {
    if (!allSuggestions) {
        return undefined;
    }

    let suggestion: SearchQueryTagSuggestion | undefined;
    if (tag.type === "text") {
        suggestion = { value: tag.value, text: `"${tag.value}"`, type: "text" };
    } else if (tag.type === "place") {
        const [ text, lat, lng ] = (tag.value ?? "").split("/");
        suggestion = { value: tag.value, text: text, type: "place" };
    } else if (tag.type === "publication_filter") {
        const parts = (tag.value ?? "").split("/");
        const name = parts.slice(0, -1).join("/");
        suggestion = { value: tag.value, text: name, type: "publication_filter" };
    } else {
        suggestion = allSuggestions.find(st => st.type === tag.type && st.value === tag.value);
    }
    return suggestion;
}
